<div id="content">
  <button class = "generateButton" (click)="saveTag()" [ngStyle]="{'visibility':  (((tag === tagType.QR) || (tag === tagType.BAR)) && (leftQRTags > 0) && barcodeIsValid) ? 'visible' : 'hidden'}" i18n="@@tag.save">Zapisz</button>
  <div id="subContent" [style.marginTop.px] = '0'>
    <div class="column">
      <h1 i18n="@@tag.type">Typ znacznika:</h1>

      <mat-selection-list [multiple]="false">
        <mat-list-option (click)="chooseTag(tagType.QR)">
          <div class="listOption">
            <img class="imgInfo"  [src]="tag === tagType.QR ? '/assets/tag_active.png' : '/assets/tag_inactive.png' " height="100%" >
            <a [ngStyle]="{color: tag === tagType.QR ? 'rgb(94, 137, 250)' : 'rgb(245, 245, 245)'}">QR</a>
          </div>
        </mat-list-option>

        <mat-list-option (click)="chooseTag(tagType.NFC)">
          <div class="listOption">
            <img class="imgInfo"  [src]="tag === tagType.NFC ? '/assets/nfc_active.png' : '/assets/nfc_inactive.png' " height="100%" >
            <a [ngStyle]="{color: tag === tagType.NFC ? 'rgb(94, 137, 250)' : 'rgb(245, 245, 245)'}">NFC</a>
          </div>
        </mat-list-option>

        <mat-list-option (click)="chooseTag(tagType.UHF)">
          <div class="listOption">
            <img class="imgInfo"  [src]="tag === tagType.UHF ? '/assets/uhf_active.png' : '/assets/uhf_inactive.png' " height="100%" >
            <a [ngStyle]="{color: tag === tagType.UHF ? 'rgb(94, 137, 250)' : 'rgb(245, 245, 245)'}">UHF</a>
          </div>
        </mat-list-option>

        <mat-list-option (click)="chooseTag(tagType.BAR)">
          <div class="listOption">
            <img class="imgInfo"  [src]="tag === tagType.BAR ? '/assets/bar_active.png' : '/assets/bar_inactive.png' " height="100%" >
            <a [ngStyle]="{color: tag === tagType.BAR ? 'rgb(94, 137, 250)' : 'rgb(245, 245, 245)'}">BAR</a>
          </div>
        </mat-list-option>

      </mat-selection-list>

    </div>

    <div class="column">
      <div class="qrContainer" [ngStyle]="{'display':  tag === tagType.QR ? 'inline-block' : 'none'}">
        <h1 i18n="@@tag.tagsleft">Dostępna ilość: <span>{{leftQRTags}}</span></h1>
        <qrcode [width]='256' [qrdata]='UID' [errorCorrectionLevel]="'M'"></qrcode>
        <h1>UID: <span>{{UID}}</span></h1>
      </div>

      <div class="qrContainer" [ngStyle]="{'display':  tag === tagType.BAR ? 'inline-block' : 'none'}">
        <h1 i18n="@@tag.tagsleft">Dostępna ilość: <span>{{leftQRTags}}</span></h1>
        <ngx-barcode #someVar [bc-value]="EnteredBarCode" [bc-format]="selectedBarType" [bc-display-value]="true"></ngx-barcode>
        <mat-form-field class="tagData">
          <mat-label i18n="@@tag.barType">Typ kodu kreskowego:</mat-label>
          <mat-select   [(ngModel)]="selectedBarType" >
            <mat-option *ngFor="let type of BarCodes" [value]="type" >{{type}}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="tagData">
          <mat-label i18n="@@tag.barCode">Wpisz kod kreskowy:</mat-label>
          <input matInput autocomplete="off" [(ngModel)]="EnteredBarCode" >
        </mat-form-field>
      </div>

      <div class="qrContainer" [ngStyle]="{'display':  tag === tagType.NFC ? 'inline-block' : 'none'}">
        <h1 i18n="@@tag.NFCNoHardware">Brak sprzętu umożliwiającego dodanie znacznika NFC </h1>
      </div>

      <div class="qrContainer" [ngStyle]="{'display':  tag === tagType.UHF ? 'inline-block' : 'none'}">
        <h1 i18n="@@tag.UHFNoHardware">Brak sprzętu umożliwiającego dodanie znacznika UHF </h1>
      </div>

    </div>


    <div class="column">
      <div class="checkAllLine" [ngStyle]="{'display':  (tag === tagType.QR) || (tag === tagType.BAR) ? 'inline-block' : 'none'}">
        <h1 i18n="@@tag.initData">Zainicjalizuj dane:</h1>

        <mat-form-field class="tagData">
          <mat-label >{{FieldsTitles[fieldType.Title]}}</mat-label>
          <input matInput autocomplete="off" [(ngModel)]="FieldsValues[fieldType.Title]">
        </mat-form-field>

        <mat-form-field class="tagData">
          <mat-label >{{FieldsTitles[fieldType.Description]}}</mat-label>
          <input matInput autocomplete="off" [(ngModel)]="FieldsValues[fieldType.Description]">
        </mat-form-field>

        <mat-form-field class="tagData">
          <mat-label >{{FieldsTitles[fieldType.EvidNumber]}}</mat-label>
          <input matInput autocomplete="off" [(ngModel)]="FieldsValues[fieldType.EvidNumber]" >
        </mat-form-field>

        <mat-form-field class="tagData">
          <mat-label>{{FieldsTitles[fieldType.PurchaseDate]}}</mat-label>
          <input matInput [matDatepicker]="picker" autocomplete="off" [(ngModel)]="FieldsValues[fieldType.PurchaseDate]">
          <mat-datepicker-toggle matSuffix [for]="picker">
          </mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        <mat-form-field class="tagData">
          <mat-label>{{FieldsTitles[fieldType.Location]}}</mat-label>
          <mat-select   value={{FieldsTitles[fieldType.Location]}} >
            <mat-option *ngFor="let loc of locations" [value]="loc" >{{loc}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="tagData">
          <mat-label >{{FieldsTitles[fieldType.Category]}}</mat-label>
          <input matInput autocomplete="off" [(ngModel)]="FieldsValues[fieldType.Category]">
        </mat-form-field>

        <mat-form-field class="tagData">
          <mat-label >{{FieldsTitles[fieldType.Mark]}}</mat-label>
          <input matInput autocomplete="off" [(ngModel)]="FieldsValues[fieldType.Mark]">
        </mat-form-field>

        <mat-form-field class="tagData">
          <mat-label >{{FieldsTitles[fieldType.Size]}}</mat-label>
          <input matInput autocomplete="off" [(ngModel)]="FieldsValues[fieldType.Size]">
        </mat-form-field>

        <mat-form-field class="tagData">
          <mat-label >{{FieldsTitles[fieldType.Remarks]}}</mat-label>
          <input matInput autocomplete="off" [(ngModel)]="FieldsValues[fieldType.Remarks]">
        </mat-form-field>
      </div>
    </div>
  </div>
</div>
